// extracted by mini-css-extract-plugin
export default {"menu-items":"style_menu-items__uD8+x","selected":"style_selected__jtd8Z"};